import { Reducer } from 'redux';
import { createSlice } from 'common/modules/create-slice';

export interface CollectionAttributionState {
    byLineItemId: Record<string, string>;
}

export const initialCollectionAttributionState: CollectionAttributionState = {
    byLineItemId: {},
};

const { reducer, configureAction } = createSlice(
    initialCollectionAttributionState,
    'COLLECTION_ATTRIBUTION'
);

export const rememberLines = configureAction<Record<string, string>>(
    'REMEMBER_LINES',
    (lines) => (state) => ({ byLineItemId: { ...state.byLineItemId, ...lines } })
);

export const forgetLines = configureAction<string[]>('FORGET_LINES', (ids) => (state) => {
    const byLineItemId = { ...state.byLineItemId };
    ids.forEach((id) => delete byLineItemId[id]);
    return { byLineItemId };
});

// Drops attribution for lines no longer in the cart after a cart update.
export const collectionAttributionReducer: Reducer<CollectionAttributionState> = (
    state = initialCollectionAttributionState,
    action
) => {
    const lineItems = action.type === 'CART/UPDATE' ? action.payload?.cart?.lineItems : undefined;
    if (!Array.isArray(lineItems)) {
        return reducer(state, action);
    }
    const live = new Set(lineItems.map((item: { id: string | number }) => String(item.id)));
    const entries = Object.entries(state.byLineItemId).filter(([id]) => live.has(id));
    if (entries.length === Object.keys(state.byLineItemId).length) {
        return state;
    }
    return { byLineItemId: Object.fromEntries(entries) };
};
